import React from 'react'
import { map, filter } from 'libraries/lodash'
import cx from 'classnames'
import { ACCOUNT_MENU as accountMenu } from 'constants/account-menu'
import { NavigationItem } from 'components/account/Navigation'
import Hidden from '@material-ui/core/Hidden'
import Grid from '@material-ui/core/Grid'

const NavigationItems = ({ view, userIs, gridWidth = 12 }) => (
  map(accountMenu, (item, itemView) => {
    const { label, visible, role } = item
    const active = itemView === view
    const buttonCxNames = cx('ttc b', { 'bg-ghost-grey ba b--cadet-blue': !active }, { 'account-nav-button': active })
    const display = visible && (userIs(role) || !role)

    return display && (
      <Grid item xs={gridWidth} key={itemView}>
        <NavigationItem
          className={cx('', { grey: !active, 'dark-cyan': active })}
          {...{ label, active, buttonCxNames }}
          view={itemView}
        />
      </Grid>
    )
  })
)

const Header = ({ view = 'details', userIs }) => {
  const displayItems = filter(accountMenu, (item) => item.visible && (userIs(item.role) || !item.role))
  const gridWidth = 12 / displayItems.length

  return (
    <>
      <Hidden xsDown mdUp>
        <Grid container className='f7 mt0 ph8' spacing={2}>
          <NavigationItems {...{ view, userIs, gridWidth }} />
        </Grid>
      </Hidden>
      <Hidden smUp>
        <Grid container spacing={2} className='f7 ph9-t ph8-m mt4'>
          <NavigationItems {...{ view, userIs }} />
        </Grid>
      </Hidden>
    </>
  )
}

export default Header
